module.exports = __webpack_public_path__ + "media/public/images/vacina.1-0a30a107b57a15919f13bffecf856a49.png";